

export class CatalogCommonConstants {
  public static readonly ROUTE_PARAMS = {
    CHANGE_ID: 'changeId' as const,
    CATEGORY_ID: 'categoryId' as const,
    DEPARTMENT_ID: 'departmentId' as const,
    ROOM_ID: 'roomId' as const,
    PROGRAM_ID: 'programId' as const,
    PROJECT_ID: 'projectId' as const,
    STATUS_FILTER: 'statusFilters' as const,
    SEARCH_KEY: 'search' as const
  };


}